export default __webpack_public_path__ + "static/riley@2x-dc845779b7fca4fcded475baa8e237aa.jpg";